import React from 'react';
import { Box, Container, Divider } from '@hover/blueprint';
import {
  BackToTopButton,
  ContactUs,
  HelpFulLinksTabletDesktop,
  Layout,
  StillHaveQuestions,
} from '../common';
import Content from './Content';
import HeroWrapper from './HeroWrapper';
import { ITermsOfUseContent } from '../../interfaces/ITermsOfUseContent';

interface Props {
  hero?: React.ReactNode;
  description: React.ReactNode;
  tableOfContents: React.ReactNode;
  content: Array<ITermsOfUseContent>;
}

const Wrapper: React.FC<Props> = ({
  hero,
  content,
  description,
  tableOfContents,
}) => (
  <Layout
    title="Terms of use"
    navbarBackgroundColor="green.100"
    isNavbarWhite={false}
    titleColor="neutral.900"
  >
    <HeroWrapper heroContent={hero} />
    <Container
      maxW="100%"
      position="relative"
      overflow="visible"
      px={500}
      centerContent
    >
      <Box w="100%" maxW="1200px">
        <Box
          h="418px"
          w="276px"
          zIndex={1}
          d={{ base: 'none', tablet: 'block' }}
          position="sticky"
          top="20vh"
          mb={1000}
        >
          <HelpFulLinksTabletDesktop />
        </Box>
        <Box
          maxW="780px"
          w="100%"
          ml={{ base: 0, tablet: '134px' }}
          flexDir="column"
          mb={1000}
        >
          {description}
          {tableOfContents}
          <Content termsContent={content} />
          <Box d={{ base: 'flex', tablet: 'none' }} flexDir="column" mt={700}>
            <Divider
              borderColor="neutral.300"
              mt={0}
              mb={200}
              borderWidth="1px"
              borderTopWidth={0}
            />
            <ContactUs />
            <Divider
              borderColor="neutral.300"
              mt={200}
              mb={0}
              borderWidth="1px"
              borderTopWidth={0}
            />
          </Box>
        </Box>
      </Box>
    </Container>
    <StillHaveQuestions />
    <BackToTopButton />
  </Layout>
);

Wrapper.defaultProps = {
  hero: null,
};

export default Wrapper;
